<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- Filter search -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="Pitch Name" prop="pitchName">
                <a-input v-model="queryParam.pitchName" placeholder="Please enter pitch name" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- Toolbar -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['golf:pitch:add']">
          <a-icon type="plus" />Add
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['golf:pitch:edit']">-->
<!--          <a-icon type="edit" />Edit-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['golf:pitch:remove']">-->
<!--          <a-icon type="delete" />Delete-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['golf:pitch:export']">-->
<!--          <a-icon type="download" />Export-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- Create / edit -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <pitch-price
        :visible="pitchPriceVisible"
        :pitch-id="currentPitchId"
        :pitch-name="currentPitchName"
        @close="closePitchPrice"
      />
      <!-- Data table -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['golf:pitch:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['golf:pitch:edit']">
            <a-icon type="edit" />Edit
          </a>
          <a-divider type="vertical" />
          <a @click="openPitchPrice(record)">
            <a-icon type="money-collect" />Pitch Pricing
          </a>
          <a-divider type="vertical" v-hasPermi="['golf:pitch:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['golf:pitch:remove']">
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <!-- Pagination -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePitch, delPitch } from '@/api/golf/pitch'
import CreateForm from './modules/CreateForm'
import PitchPrice from '../pitchPrice/index'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Pitch',
  components: {
    CreateForm,
    PitchPrice
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // Disable when not exactly one row selected
      single: true,
      // Disable when no rows selected
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      pitchPriceVisible: false,
      currentPitchId: null,
      currentPitchName: '',
      // Query parameters
      queryParam: {
        pitchName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Pitch Name',
          dataIndex: 'pitchName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Rating',
          dataIndex: 'rating',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Business Start Time',
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Business End Time',
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Actions',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** Query pitch list */
    getList () {
      this.loading = true
      pagePitch(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    openPitchPrice (record) {
      this.currentPitchId = record.id
      this.currentPitchName = record.pitchName || ''
      this.pitchPriceVisible = true
    },
    closePitchPrice () {
      this.pitchPriceVisible = false
    },

    /** Search action */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** Reset action */
    resetQuery () {
      this.queryParam = {
        pitchName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** Delete action */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm deletion of selected data?',
        content: 'Selected IDs: ' + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPitch(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          // Cancel: clear delete id list
          that.ids = []
        }
      })
    },
    /** Export action */
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Confirm export?',
        content: 'This will export all data under current filters, not just selected rows.',
        onOk () {
          that.download('golf/golf-pitch/export', {
            ...that.queryParam
          }, `pitch_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
